<template>
  <el-form :inline="true" :model="queryLoginParam" class="mainSearch" v-if="activeName=='login'">
    <el-form-item label="用户名">
      <el-input v-model="queryLoginParam.username" placeholder="用户名" />
    </el-form-item>
    <el-form-item>
      <el-button type="danger" @click="getListUserLoginLog"><el-icon class="elicon"><Search /></el-icon>查询</el-button>
      <el-button @click="resetSearchLogin">重置</el-button>
    </el-form-item>
  </el-form>
  <el-form :inline="true" :model="queryOperateParam" class="mainSearch" v-if="activeName=='operate'">
    <el-form-item label="用户名">
      <el-input v-model="queryOperateParam.username" placeholder="用户名" />
    </el-form-item>
    <el-form-item>
      <el-button type="danger" @click="getListUserOperateLog"><el-icon class="elicon"><Search /></el-icon>查询</el-button>
      <el-button @click="resetSearchOperate">重置</el-button>
    </el-form-item>
  </el-form>
  <el-row class="mainTableBox">
    <el-col :span="24"  class="mpadding">
  <el-tabs class="tabs-log" v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="登录日志" name="login">
      <el-row class="mainTableBox">
    <el-col :span="24">
      <el-table
        :data="tableData"
        v-loading="loadingData"
        class="mainTable"
        default-expand-all
        row-key="logid"
        stripe
      >
        <el-table-column label="用户名" prop="username" sortable />
        <el-table-column label="IP" prop="ip" />
        <el-table-column label="操作系统" prop="os" sortable />
        <el-table-column label="客户端" prop="clienttype" />
        <el-table-column label="浏览器" prop="browser" sortable />
        <el-table-column label="状态" prop="status" sortable>
          <template #default="scope">
            <el-tag
              round
              :type="scope.row.status === 1 ? 'success' : 'danger'"
              disable-transitions
              v-text="util.showUserLoginStatus(scope.row.status)"
            ></el-tag>
          </template>
        </el-table-column>
        <el-table-column label="日期" prop="created" sortable>
          <template #default="scope">
            <span
              v-text="
                util.formatDateUnix(scope.row.created, 'yyyy-MM-dd hh:mm')
              "
            ></span>
          </template>
        </el-table-column>
      </el-table>
      </el-col>
      </el-row>

      <el-row class="mainTableBottom">
        <el-col :span="8"
          ><div>
            <!-- <el-button
          type="danger"
          >添加用户</el-button> -->
          </div></el-col
        >
        <el-col :span="16">
          <div style="float: right">
            <el-pagination
              v-model:page-size="queryLoginParam.pageSize"
              :page-sizes="[10, 15, 20, 30]"
              :background="true"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="changeChangeSize"
              @current-change="changePage"
            />
          </div>
        </el-col>
      </el-row>
    </el-tab-pane>
    <el-tab-pane label="操作日志" name="operate">
      <el-row class="mainTableBox">
    <el-col :span="24">
      <el-table :data="tableOperateData" v-loading="loadingData" class="mainTable" stripe row-key="logid">
        <el-table-column label="用户名" prop="username" sortable />
        <el-table-column label="操作类型" prop="operatetype" sortable />
        <el-table-column label="说明" prop="note" />
        <el-table-column label="请求URL" prop="operurl" />
        <el-table-column label="IP" prop="operip" />
        <el-table-column label="状态" prop="status" sortable>
          <template #default="scope">
            <el-tag
              round
              :type="scope.row.status === 200 ? 'success' : 'danger'"
              disable-transitions
              v-text="scope.row.status"
            ></el-tag>
          </template>
        </el-table-column>
        <el-table-column label="日期" prop="created" sortable>
          <template #default="scope">
            <span
              v-text="
                util.formatDateUnix(scope.row.created, 'yyyy-MM-dd hh:mm')
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column label="详情" type="expand" width="100">
          <template #default="props">
            <div m="3">
              <p m="t-0 b-2">请求方法: {{ props.row.method }}</p>
              <p m="t-0 b-2">请求内容: {{ props.row.content }}</p>
              <p m="t-0 b-2">错误信息: {{ props.row.errormsg }}</p>
            </div>
          </template>
        </el-table-column>
      </el-table>
      </el-col>
      </el-row>

      <el-row class="mainTableBottom">
        <el-col :span="8"
          ><div>
            <!-- <el-button
          type="danger"
          >添加用户</el-button> -->
          </div></el-col
        >
        <el-col :span="16">
          <div style="float: right">
            <el-pagination
              :hide-on-single-page="true"
              v-model:page-size="queryOperateParam.pageSize"
              :page-sizes="[10, 15, 20, 30]"
              :background="true"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalOperate"
              @size-change="changeOperateChangeSize"
              @current-change="changeOperatePage"
            />
          </div>
        </el-col>
      </el-row>
    </el-tab-pane>
  </el-tabs>
</el-col>
</el-row>
</template>
<script setup>
import { ref, onMounted } from "vue";
import { ListUserLoginLog, ListUserOperateLog } from "@/api/log";
import util from "@/util/tool.js";

const total = ref(0);
const totalOperate = ref(0);
const pageSize = ref(15); //每页显示条数
const tableData = ref([]); //登录日志集合
const tableOperateData = ref([]); //操作日志集合

const activeName = ref("login");
const handleClick = (tab) => {
  console.log(tab.props.name);
};

const loadingData = ref(true);

//搜索查询
const queryLoginParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  username: "",
});
const resetSearchLogin = () => {
  queryLoginParam.value = {
    pageNo: 1,
    pageSize: pageSize.value,
    username: '',
  };
  getListUserLoginLog();
};
const queryOperateParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  username: "",
});
const resetSearchOperate = () => {
  queryOperateParam.value = {
    pageNo: 1,
    pageSize: pageSize.value,
    username: '',
  };
  getListUserOperateLog();
};

onMounted(() => {
  getListUserLoginLog();
  getListUserOperateLog();
});

//分页
const changePage = (current) => {
  queryLoginParam.value.pageNo = current;
  getListUserLoginLog();
};
const changeChangeSize = (size) => {
  pageSize.value = size;
  queryLoginParam.value.pageSize = size;
  getListUserLoginLog();
};
//用户登录日志列表API
const getListUserLoginLog = () => {
  ListUserLoginLog(queryLoginParam.value).then((res) => {
    tableData.value = res.data.extend.pages.list;
    total.value = res.data.extend.pages.total;
    queryLoginParam.value.pageSize = pageSize.value;
    loadingData.value = false
  });
};

//分页
const changeOperatePage = (current) => {
  queryOperateParam.value.pageNo = current;
  getListUserOperateLog();
};
const changeOperateChangeSize = (size) => {
  pageSize.value = size;
  queryOperateParam.value.pageSize = size;
  getListUserOperateLog();
};
const getListUserOperateLog = () => {
  ListUserOperateLog(queryOperateParam.value).then((res) => {
    tableOperateData.value = res.data.extend.pages.list;
    totalOperate.value = res.data.extend.pages.total;
    queryOperateParam.value.pageSize = pageSize.value;
    loadingData.value = false
  });
};
</script>